<template>
    <ul class="avaliacao-estrela">
        <li v-for="(item, index) in nrEstrelas" 
            :class="(index < nrAvaliacao ? 'active' : 'false') +' '+ (indexSelecao != null && indexSelecao >= index ?'active':'' )" 
            :data-nr="item" 
            :key="index" 
            @mouseover="selecionaEstrela(index)" 
            @mouseleave="removeEstrela(index)"
            @click="click(index+1)">
            <i class="fas fa-star" ></i>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'Avaliacao',
        props: {
            nrEstrelas: {
                type: Number,
                default: 0
            },
            nrAvaliacao: {
                type: Number,
                default: 0
            },
            click: {
                type: Function,
            }
        },
        data: function () {
            return {
                indexSelecao: null,
            }
        },
        methods: {
            selecionaEstrela(index) {
                this.indexSelecao = index;
            },

            removeEstrela() {
                this.indexSelecao = null;
            },
        },

        mounted() {
            //let $this = this;

            //$('.avaliacao-estrela li').hover(function () {
            //    let nr = $(this).data('nr');
                
            //    $('.avaliacao-estrela li').each(function () {
            //        let _nr = $(this).data('nr');
            //        $(this)[(_nr <= nr) ? 'addClass' : 'removeClass']('active');
            //    });
            //},
            //function () {                    
            //    $('.avaliacao-estrela li').each(function () {                    
            //        let _nr = $(this).data('nr');
            //        $(this)[(_nr <= $this.nrAvaliacao) ? 'addClass' : 'removeClass']('active');
            //    });
            //});
        }
    }
</script>

<style lang="scss">
    .avaliacao-estrela {
        list-style: none;
        margin: 0;
        padding: 0;
        display: inline-block;
    }

    .avaliacao-estrela li {
        float: left;
        font-size: 3rem;
        margin-left: 0.7rem;
        color: #aeb8bf;
        transition: .4s;
        cursor: pointer;
    }
    /*.avaliacao-estrela li:hover {
        font-size: 3.2rem;
        color: #ffc107;
    }*/

    .avaliacao-estrela li.active {
        font-size: 3.2rem;
        color: #ffc107;
    }


</style>
